import apiSlice from "./apiSlice";
const notificationApiSlice = apiSlice.injectEndpoints({
  endpoints: (builder) => ({
    getAllNotifications: builder.query({
      query: (req) => ({
        url: `notification`,
        params: req,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["AllNotifications"],
    }),
    viewNotification: builder.mutation({
      query: (id) => ({
        url: `notification/${id}/viewed`,
        method: "PUT",
      }),
      invalidatesTags: ["AllNotifications"],
    }),
    getNotifications: builder.query({
      query: (userId) => ({
        url: `/notification/${userId}`,
      }),
      keepUnusedDataFor: 0,
      refetchOnMountOrArgChange: true,
      providesTags: ["Notifications"],
    }),
  }),
});

export const {
  useGetAllNotificationsQuery,
  useViewNotificationMutation,
  useGetNotificationsQuery,
} = notificationApiSlice;